import { Outlet } from "react-router-dom";
import { IpMetaContext, PagedResponse, PRCostCenter, useIpOwners } from "./patent_renewals";
import { NavLink } from "src/navigation";
import clsx from "clsx";
import { useQuery } from "@tanstack/react-query";
import { parseBackend } from "src/backend";
import _ from "lodash";


export function IpMetaContextProvider({children}) {
  const {owners, postOwner} = useIpOwners()
  //const {costCenters, postCostCenter} = useIpCostCenters()
  //const deleteOwner = ({id: string}) => Promise.resolve({})
  //const deleteCostCenter = ({id: string}) => Promise.resolve({})


  const { data: costCenters } = useQuery({
    queryKey: ['ip-owners'],
    queryFn: () =>
      Promise.all(owners.map(o => parseBackend(fetch(`/api/patent-renewal/pass-through/api/v1/owners/${o.id}/cost_centers`)))).then(
        (ccs: PagedResponse<PRCostCenter>[]) => ccs.flatMap(cc => cc.items),
      ),
    enabled: !!owners,
    placeholderData: [],
  })

  //console.log({owners, costCenters})

  const ownerByCostCenterId: Record<string, string> = _(costCenters || [])
    .keyBy('id')
    .mapValues('owner_id')
    .value()

  const costCenterById = _.keyBy(costCenters, cc => cc.id)
  const value = {owners, postOwner, costCenters, ownerByCostCenterId, costCenterById} //, deleteOwner, costCenters, postCostCenter, deleteCostCenter}

  return (
    <IpMetaContext.Provider {...{value}}>
      {children}
    </IpMetaContext.Provider>
  )
}

function navLinkStyle({ isActive }) {
    return clsx(
        "text-base hover:text-pcx-400 whitespace-nowrap",
        isActive ? "text-pcx-500" : "text-slate-400",
    )
}

export function PrSettings() {
  return <>
    <div className="header-row pb-1 flex flex-row gap-x-6 gap-y-2 w-full flex-wrap sm:flex-nowrap">
      <NavLink className={navLinkStyle} to="owners">Manage Owners</NavLink>
      <NavLink className={navLinkStyle} to="credentials">Credentials</NavLink>
      {/* <NavLink className={navLinkStyle} to="cost-centers">Manage Cost Centers</NavLink> */}
    </div>
    <Outlet />
  </>
}